import { THREADS_API_URL } from './constants';

export type FetchThreadsParams = {
	userId: string;
	cloudId: string;
	promptOverride?: string;
};

export function fetchThreads({ userId, cloudId, promptOverride }: FetchThreadsParams) {
	return fetch(THREADS_API_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Cloudid': cloudId,
			'X-Product': 'rovo',
			'X-Experience-Id': 'home-threads',
		},
		body: JSON.stringify({
			ai_feature_input: {
				user_id: userId,
				prompt_override: promptOverride,
			},
		}),
	});
}
